import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import {Provider} from "react-redux";
import {store} from "./redux/store/store";
import {BrowserRouter} from "react-router-dom";
import {checkAuthRequest} from "./redux/slices/authSlice";

store.dispatch(checkAuthRequest());

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
        <Provider store={store}>
          <App/>
        </Provider>
    </BrowserRouter>
  </React.StrictMode>
);

